import { render, staticRenderFns } from "./add-channel.vue?vue&type=template&id=41b38cda&scoped=true&lang=pug&"
import script from "./add-channel.vue?vue&type=script&lang=coffee&"
export * from "./add-channel.vue?vue&type=script&lang=coffee&"
import style0 from "./add-channel.vue?vue&type=style&index=0&id=41b38cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b38cda",
  null
  
)

export default component.exports